// LayoutPlain.tsx
import { Typography } from "antd";
import { ReactNode } from "react";

interface LayoutPlainProps {
    children: ReactNode;
}

const LayoutPlain = ({ children }: LayoutPlainProps) => {
    return (
        <div className="flex min-h-screen w-screen flex-col bg-blue-gray-50 dark:bg-blue-gray-800">

            <section className="flex h-full grow items-center justify-center"> {/* Reduced padding */}
                {children}
            </section>
            <div className="flex flex-col justify-center px-8 py-4 sm:justify-start items-center w-full">
                <Typography className="mx-auto">{`© Copyright ${new Date().getFullYear()} | Sayur Sembalun`}</Typography>
                {/* <Typography className="mx-auto">Sayur Sembalun</Typography> */}
            </div>
        </div>
    );
};

export default LayoutPlain;
